// extracted by mini-css-extract-plugin
module.exports = {"detailsSection":"ProductShimmer_detailsSection___bDFz","hr":"ProductShimmer_hr__XSOTa"};